"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.appendAuthHeader = appendAuthHeader;
exports.setHttpBaseURL = setHttpBaseURL;
exports.setupHttpHeaders = setupHttpHeaders;
exports.setupSSRHttpHeaders = setupSSRHttpHeaders;
exports.setupStaticHttpHeaders = setupStaticHttpHeaders;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _http2 = require("@tajawal/ct-web-account-sdk/lib/utils/http.utils");
var _omitBy = _interopRequireDefault(require("lodash/omitBy"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
function appendAuthHeader(token) {
  if (token) {
    _http.$http.addHeaders({
      Authorization: "Bearer " + token
    });
  }
}
function setupStaticHttpHeaders(isMobile) {
  var headers = {
    'x-bt': isMobile ? 'mweb' : 'next'
  };
  _http.$http.addHeaders((0, _omitBy.default)(headers, _isEmpty.default));
  var authService = isMobile ? 'mweb' : 'web';
  (0, _http2.setupAuthHttpService)(authService, false, _http.$http);
}
function setupHttpHeaders(language, userToken, partnerReferrer, xAppName, splitId) {
  var headers = {
    'x-locale': language,
    'x-app-name': xAppName,
    'general-key': partnerReferrer,
    'x-referrer': partnerReferrer,
    'experiment-id': userToken ? null : splitId
  };
  if (userToken) {
    appendAuthHeader(userToken);
  }
  _http.$http.addHeaders((0, _omitBy.default)(headers, _isEmpty.default));
}
function setupSSRHttpHeaders(language, currency, xAppName, userToken, partnerReferrer, isMobile, splitId) {
  var headers = {
    'x-bt': isMobile ? 'mweb' : 'next',
    'x-locale': language,
    'x-app-name': xAppName,
    'x-currency': currency,
    'general-key': partnerReferrer,
    'x-referrer': partnerReferrer,
    'experiment-id': userToken ? null : splitId
  };
  _http.$http.overrideHeaders((0, _omitBy.default)(headers, _isEmpty.default));
  if (userToken) {
    appendAuthHeader(userToken);
  }
}
function setHttpBaseURL() {
  _http.$http.formatBaseUrl('https://next-dev.almosafer.com/');
}